import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DatePicker, Form, Input, Select, Checkbox } from 'antd';

import CRUDE_City from '../../../objects/City/crude'
import REDUX_City from '../../../objects/City/reducer'
import REDUX_TipiMeropriyatii from '../../../objects/TipiMeropriyatii/reducer'
import REDUX_UrovenMeropriyatiya from '../../../objects/UrovenMeropriyatiya/reducer'
import { errorCatch, GET, POST, useFormObserverContext } from 'fennec-ui';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import locale from 'antd/es/date-picker/locale/ru_RU';
import EmojiTextArea from '../../../common/EmojiTextArea';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Tooltip from '../../components/Tooltip';
dayjs.locale('ru');


const { Option } = Select;


export default function IzmenitMeropriyatiya(props) {
    const { auth, object, form, sourceKey } = props;
    const dispatch = useDispatch();

    const city = useSelector(REDUX_City.selector.array);
    const tipMeropriyatiya = useSelector(REDUX_TipiMeropriyatii.selector.array);
    const urovenMeropriyatiya = useSelector(REDUX_UrovenMeropriyatiya.selector.array);

    let orgKey = undefined;
    if (object?.organizatorFederatsiyaID) {
        orgKey = "fed";
    } else if (object?.organizatorRegionalnoeOtdelenieID) {
        orgKey = "reg";
    } else if (object?.organizatorMeropriyatiyaID) {
        orgKey = "org";
    } else if (object?.organizatorShkolaID) {
        orgKey = "school";
    }

    // const tekushchieStatusiMeropriyatii = useSelector(REDUX_TekushchieStatusiMeropriyatii.selector.array);
    useEffect(() => {
        form.resetFields();
        CRUDE_City.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_City.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
        // console.log(object)
        GET(auth, '/api/tipimeropriyatii/' + orgKey,
            ({ data }) => {
                dispatch(REDUX_TipiMeropriyatii.actions.setArray(data));
            },
            (err) => errorCatch(err));
        GET(auth, '/api/urovenmeropriyatiya/' + orgKey,
            ({ data }) => {
                dispatch(REDUX_UrovenMeropriyatiya.actions.setArray(data));
            },
            (err) => errorCatch(err));
        // CRUDE_TekushchieStatusiMeropriyatii.read(auth, (data) => {
        //     if (data.length > 0) {
        //         dispatch(REDUX_TekushchieStatusiMeropriyatii.actions.setArray(data));
        //     }
        // }, 'model', 's-id=ASC');
    }, []);
    const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);
    const tipMeropriyatiyaOptions = tipMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const urovenMeropriyatiyaOptions = urovenMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    // POST "/api/nastroikiekvairinga/byorganizator"
    // {
    //     organizatorShkolaID
    //     organizatorMeropriyatiyaID
    //     organizatorRegionalnoeOtdelenieID
    //     organizatorFederatsiyaID
    // }

    const [ekvairing, setEkvairing] = React.useState();
    useEffect(() => {
        POST(auth, '/api/nastroikiekvairinga/byorganizator', {
            organizatorShkolaID: object?.organizatorShkolaID,
            organizatorMeropriyatiyaID: object?.organizatorMeropriyatiyaID,
            organizatorRegionalnoeOtdelenieID: object?.organizatorRegionalnoeOtdelenieID,
            organizatorFederatsiyaID: object?.organizatorFederatsiyaID
        }, ({ data }) => {
            setEkvairing(data);
        }, errorCatch);
    }, [object]);
    const ekvairingOptions = ekvairing?.map((i, idx) => <Option key={i.ID} value={i.ID}>{i?.nastroiki?.nazvanie}</Option>);
    // const tekushchieStatusiMeropriyatiiOptions = tekushchieStatusiMeropriyatii.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    // const columns = () => {
    //     var c = [];
    //     c.push({
    //         title: 'Танцевальная дисциплина',
    //         render: (text, record) => {
    //             return (
    //                 <div>
    //                     {record.tantsevalnayaDistsiplina.nazvanie}
    //                 </div>
    //             );
    //         },
    //         key: 'tantsevalnayaDistsiplina',
    //     });
    //     c.push({
    //         title: 'Категория участников',
    //         render: (text, record) => {
    //             return (
    //                 <div>
    //                     {record.kategoriyaUchastnikov.nazvanie}
    //                 </div>
    //             );
    //         },
    //         key: 'kategoriyaUchastnikov',
    //     });
    //     return c;
    // };
    const shapkaUsloviiVozvrata =
        `Возврат денежных средств за билет возможен только в том случае, если билет куплен через сайт: https://social-dance.club. При покупке билетов через другие ресурсы действуют правила возврата, принятые на этих ресурсах.
Вы можете подать заявку на возврат билета не позднее начала мероприятия, нажав кнопку: «Возврат билета» (кнопка находится в личном кабинете на сайте https://social-dance.club, закладка "Заказы").
            
Возврат денежных средств за сданный билет осуществляется на внутренний аккаунт пользователя в течение 30 минут.`
    const podvalUsloviiVozvrata =
        `Если Вы хотите вернуть денежные средства со своего внутреннего аккаунта, Вам необходимо для этого подать заявление на возврат денежных средств на свою банковскую карту.
Возврат средств с внутреннего аккаунта на банковскую карту осуществляется в течение 10 дней после подачи такого заявления.
В день мероприятия прием заявлений на возврат билетов прекращается, денежные средства за билет не возвращаются.`

    const [isChangedForm, isChangedField, onValuesChange] = useFormObserverContext()
    // console.log(props.isChangedForm, props.isChangedField("nazvanieMeropriyatiya"), props.onValuesChange);
    return (
        <div className={(isChangedForm) ? "border-orange" : "border-fwhite"} style={{ padding: "5px 10px", marginBottom: "5px" }}>
            <Form
                form={form}
                onValuesChange={onValuesChange}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    nastroikaEkvairingaID: (object) ? object.nastroikaEkvairingaID : undefined,
                    nazvanieMeropriyatiya: (object) ? object.nazvanieMeropriyatiya : undefined,
                    nazvanieDlyaFinalaPp: (object) ? object.nazvanieDlyaFinalaPp : undefined,
                    nazvanieDlyaFinalaRp: (object) ? object.nazvanieDlyaFinalaRp : undefined,
                    sezonDlyaFinala: (object) ? object.sezonDlyaFinala : undefined,
                    sokrashchennoeNazvanie: (object) ? object.sokrashchennoeNazvanie : undefined,
                    tipMeropriyatiyaID: (object) ? object.tipMeropriyatiyaID : undefined,
                    urovenMeropriyatiyaID: (object) ? object.urovenMeropriyatiyaID : undefined,
                    mestoProvedeniyaID: (object) ? object.mestoProvedeniyaID : undefined,
                    vk: (object) ? object.vk : undefined,
                    isPublic: (object) ? object.isPublic : false,
                    zapreshchenoPublikovatOtsenki: (object) ? object.zapreshchenoPublikovatOtsenki : false,
                    rezultatiOpublikovani: (object) ? object.rezultatiOpublikovani : false,
                    nachaloRegistratsii: (object) ? dayjs(object.nachaloRegistratsii) : undefined,
                    pokazivaemTolkoTekushchiiTarif: (object) ? object.pokazivaemTolkoTekushchiiTarif : false,
                    // priceText: (object) ? object.priceText : undefined,
                    // shapkaUsloviiVozvrata: (object) ? object.shapkaUsloviiVozvrata : undefined,
                    // podvalUsloviiVozvrata: (object) ? object.podvalUsloviiVozvrata : undefined,
                    // reklama: (object) ? object.reklama : undefined,
                    // reklamaPopup: (object) ? object.reklamaPopup : undefined,

                    nachaloAdministrativnogoKontrolya: (object) ? dayjs(object.nachaloAdministrativnogoKontrolya) : undefined,
                    okonchanieAdministrativnogoKontrolya: (object) ? dayjs(object.okonchanieAdministrativnogoKontrolya) : undefined,
                    nachaloSorevnovaniya: (object) ? dayjs(object.nachaloSorevnovaniya) : undefined,
                    okonchanieSorevnovaniya: (object) ? dayjs(object.okonchanieSorevnovaniya) : undefined,
                    adresProvedeniya: (object) ? object.adresProvedeniya : undefined,
                    ssilkaNaYandeksKarti: (object) ? object.ssilkaNaYandeksKarti : undefined,

                    // '@kontrol': (object) ? [dayjs(object.nachaloAdministrativnogoKontrolya), dayjs(object.okonchanieAdministrativnogoKontrolya)] : undefined,
                    // '@nachalo': (object) ? [dayjs(object.nachaloSorevnovaniya), dayjs(object.okonchanieSorevnovaniya)] : undefined
                }}
            >
                {/* <Form.Item label="Текущий статус мероприятия"
                    name="tekushchiiStatusMeropriyatiyaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите текущий статус мероприятия!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {tekushchieStatusiMeropriyatiiOptions}
                    </Select>
                </Form.Item> */}
                <Form.Item
                    name="isPublic"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Опубликовано
                    </Checkbox>
                </Form.Item>
                <Form.Item label="Название мероприятия"
                    name="nazvanieMeropriyatiya"
                    rules={[{ required: true, message: 'Пожалуйста, укажите название мероприятия!' }]}
                >
                    <Input /*status={(isChangedField("nazvanieMeropriyatiya")) ? "warning" : undefined}*/ />
                </Form.Item>
                <Form.Item label="Название мероприятия в предложном падеже (для финала)"
                    name="nazvanieDlyaFinalaPp"
                    rules={[{ required: false, message: 'Пожалуйста, укажите название мероприятия в предложном падеже!' }]}
                >
                    <Input /*status={(isChangedField("nazvanieDlyaFinalaPp")) ? "warning" : undefined}*/ />
                </Form.Item>
                <Form.Item label="Название мероприятия в родительном падеже (для финала)"
                    name="nazvanieDlyaFinalaRp"
                    rules={[{ required: false, message: 'Пожалуйста, укажите название мероприятия в родительном падеже!' }]}
                >
                    <Input /*status={(isChangedField("nazvanieDlyaFinalaRp")) ? "warning" : undefined}*/ />
                </Form.Item>
                <Form.Item label="Сезон (для финала)"
                    name="sezonDlyaFinala"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сезон!' }]}
                >
                    <Input /*status={(isChangedField("sezonDlyaFinala")) ? "warning" : undefined}*/ />
                </Form.Item>
                {/* <Form.Item label="Сокращенное название"
                    name="sokrashchennoeNazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите сокращенное название!' }]}
                >
                    <Input />
                </Form.Item> */}
                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item label="Тип мероприятия"
                            name="tipMeropriyatiyaID"
                            rules={[{ required: true, message: 'Пожалуйста, укажите тип мероприятия!' }]}
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {tipMeropriyatiyaOptions}
                            </Select>
                        </Form.Item>
                    </div>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item label="Уровень мероприятия"
                            name="urovenMeropriyatiyaID"
                            rules={[{ required: true, message: 'Пожалуйста, укажите уровень мероприятия!' }]}
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            // filterSort={(optionA, optionB) =>
                            //     optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            // }
                            >
                                {urovenMeropriyatiyaOptions}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
                <Form.Item label="Место проведения"
                    name="mestoProvedeniyaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите город!' }]}
                >
                    <Select
                        placeholder="Город"
                        allowClear
                        showSearch
                        style={{ width: 200 }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {cityOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Адрес проведения"
                    name="adresProvedeniya"
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Ссылка на яндекс карты"
                    name="ssilkaNaYandeksKarti"
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Ссылка на мероприятие в ВК"
                    name="vk"
                >
                    <Input />
                </Form.Item>

                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item
                            name={"nachaloRegistratsii"}
                            label={"Начало продажи билетов"}
                            tooltip={'До этого времени не будет БОЛЬШОЙ зеленой кнопки "Купить билет". Покупка билета до начала продаж ЗАПРЕЩЕНА!'}
                            rules={[{ required: true, message: 'Укажите время начала продажи билетов!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item
                            name={"nachaloAdministrativnogoKontrolya"}
                            label={"Начало административного контроля"}
                            tooltip={'У контролера появляется возможность проверки билетов (доступ к сканеру qr-кодов)'}
                            rules={[{ required: false, message: 'Укажите время начала административного контроля!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item
                            name={"okonchanieAdministrativnogoKontrolya"}
                            label={"Окончание административного контроля"}
                            rules={[{ required: false, message: 'Укажите время окончания административного контроля!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item
                            name={"nachaloSorevnovaniya"}
                            label={"Начало мероприятия"}
                            rules={[{ required: true, message: 'Укажите время начала мероприятия!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                    <div style={{ flexBasis: "50%" }}>
                        <Form.Item
                            name={"okonchanieSorevnovaniya"}
                            label={"Окончание мероприятия"}
                            rules={[{ required: true, message: 'Укажите время окончания мероприятия!' }]}
                        >
                            <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                        </Form.Item>
                    </div>
                </div>
                <Form.Item
                    name="pokazivaemTolkoTekushchiiTarif"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Показывать только текущий тариф
                        <Tooltip title='На странице мероприятия пользователь увидит только текущий тариф в каждой позиции, а не сетку тарифов.' />
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name="zapreshchenoPublikovatOtsenki"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Запрещено публиковать оценки
                        <Tooltip title='После проведения соревнования запрещена детализация оценок судей в открытых источниках Федерации.' />
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name="rezultatiOpublikovani"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Результаты опубликованы
                        <Tooltip title='После проведения соревнования размещение результатов в открытых источниках Федерации.' />
                    </Checkbox>
                </Form.Item>
                <div style={{ display: "flex", gap: "5px" }}>
                    {ekvairing && <div style={{ flexBasis: "50%" }}>
                        <Form.Item label="Эквайринг"
                            name="nastroikaEkvairingaID"
                            rules={[{ required: true, message: 'Пожалуйста, укажите эквайринг!' }]}
                        >
                            <Select
                                // allowClear
                                showSearch
                                // style={{ width: 200 }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children?.toLowerCase().localeCompare(optionB.children?.toLowerCase())
                                }
                            >
                                {ekvairingOptions}
                            </Select>
                        </Form.Item>
                    </div>}
                    <div style={{ flexBasis: "50%" }}>

                    </div>
                </div>
            </Form>
        </div>
    );
}
